import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ 
  title, 
  showLeaderboard = false, 
  showNewPlayer = true, 
  showNewGame = false,
  showStartTime = false,
  startTime = null,
  onNewGame = null,
  onPhotoSubmissions = null,
  showContributors = false,
  onShowContributors = null,
  showInviteFriends = false,
  onInviteFriends = null
}) => {
  console.log('Header props:', { onPhotoSubmissions, showLeaderboard, showNewPlayer, showNewGame });
  console.log('onPhotoSubmissions type:', typeof onPhotoSubmissions);
  return (
    <header className="header">
      <h3 className="player-welcome">{title}</h3>
      <div className="float-right">
        <div className="header-links">
          {showStartTime && startTime && (
            <h4 className="start-time-h4">
              Start Time: <span className="start-time-span">{startTime.toLocaleTimeString()}</span>
            </h4>
          )}
          
          {showNewGame && (
            <button 
              className="new-game-btn" 
              onClick={onNewGame}
            >
              New Game
            </button>
          )}
          
          {showLeaderboard && (
            <Link to="/leaderBoard">
              <button className="go-to-leaderboard-btn">Leaderboard</button>
            </Link>
          )}
          
          {showNewPlayer && (
            <Link to="/">
              <button className="new-player-btn">New Player</button>
            </Link>
          )}
          
          {showContributors && (
            <button 
              className="new-game-btn"
              onClick={onShowContributors}
            >
              Credits
            </button>
          )}
          
          {showInviteFriends && (
            <button 
              className="invite-friends-btn"
              onClick={onInviteFriends}
            >
              📱 Invite
            </button>
          )}
          
          <button 
            className="photo-submissions-btn"
            onClick={onPhotoSubmissions || (() => console.log('No photo submissions function'))}
          >
            Submit Photos
          </button>
          
          <a 
            href="https://www.nicolecodegirl.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="website-link"
          >
            <button className="back-to-website-btn">
              <img 
                src="/photos/nicoleLogo2.png" 
                alt="NicoleCodeGirl Logo" 
                className="website-logo"
              />
              <span className="website-text">Main Website</span>
            </button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header; 